<template>
    <main id="mainCtrl">
        <form style="height: calc(100vh - 95px); overflow-x: hidden;">
            <div style="height: 100%; overflow-x: hidden;">

                <div class="printing-tables">
                    <h4>
                        <b>QR-код "Оставьте отзыв" А3, А4, А5</b>
                    </h4>
                    <div>
                        <div class="qr-img-box">
                            <img class="qr-img-background" src="/img/printing_reviews_A3.svg" >
                            <img class="qr-img" :src="img" >
                        </div>
                        <div class="qr-links-box">
                            <p
                                style="cursor: pointer; color: #3c8dbc;"
                                @click="downloadPDF('A3')"
                            >
                                <i
                                    class="fas fa-file-pdf"
                                    style="cursor: pointer; color: #3c8dbc; padding: 5px"
                                >

                                </i>
                                Скачать файл для печати A3
                            </p>

                            <p
                                style="cursor: pointer; color: #3c8dbc;"
                                @click="downloadPDF('A4')"
                            >
                                <i
                                    class="fas fa-file-pdf"
                                    style="cursor: pointer; color: #3c8dbc; padding: 5px"
                                >

                                </i>
                                 Скачать файл для печати A4
                            </p>


                            <p
                                style="cursor: pointer; color: #3c8dbc;"
                                @click="downloadPDF('A5')"
                            >
                                <i
                                    class="fas fa-file-pdf"
                                    style="cursor: pointer; color: #3c8dbc; padding: 5px"
                                >
                                </i>
                                 Скачать файл для печати A5
                            </p>
                        </div>

                    </div>
                </div>



            </div>
        </form>
    </main>



</template>
<script>
export default {
    mounted() {

    },
    data(){
        return {
            img:{},
        }
    },
    methods:{
        downloadPDF(format) {
            window.open('/clinics/promoMaterials/printing/downloadQR?formatPDF='+ format)
        }
    },
    created() {
        this.axios.get('/clinics/promoMaterials/printing/getReviewsQR', {
            headers:{
                'content-type': 'image/png',
                'accept': 'image/png'
            },
            responseType: 'blob'
        }).then(response => {
            this.img = window.webkitURL.createObjectURL(response.data)
        });
    }
}
</script>
<style>
.printing-tables{

    & .qr-img-box{
        position: relative;

        & .qr-img {
            height: 120px;
            position: absolute;
            top: 187px;
            left: 81px;
        }

        & .qr-img-background{
            border: solid 1px #CCCCCC;
        }
    }

    & img{
        height: 400px;
    }

    & .qr-links-box{
        display: flex;
        flex-direction: column;
        margin-top: 1em;

        & p{
            margin: 0;
        }
    }
}
</style>
